import { updateUserRoles, init } from '@store/slice/permissionsSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from '@table-library/react-table-library/table'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import useDeleteButton from '@hook/useDeleteButton'
import useDynamicForm from '@hook/useDynamicForm'
import usePathGenerator from '@hook/usePathGenerator'
import Buttons from '@ui/elements/Buttons'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const UserRolesList = () => {
  const [t] = useTranslation('permissions')
  const toggleDynamicForm = useDynamicForm()
  const { roles } = useSelector(state => state.permissions)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const deleteButton = useDeleteButton()
  const getDynamicPath = usePathGenerator()
  const theme = useTheme(getTheme())
  const resize = { resizerHighlight: "#dde2eb", resizerWidth: 5 }

  const dataRoles = { nodes: [] }
  if (roles) {
    dataRoles.nodes = Object.values(roles)
  }

  const goToAuthorizationsPage = id => navigate(getDynamicPath('manageAuthorizations', { id }))

  const removeUserRole = userRole => {
    const { links, id } = userRole
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const userRolesList = { ...roles }
        delete userRolesList[id]
        dispatch(updateUserRoles({ ...userRolesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: userRole.role }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    if (!roles) {
      get(`${import.meta.env.VITE_API_URL}/api/user-roles`, response => {
        const { code, roles, attributes } = response
        if (code === 200) {
          dispatch(init({ roles, attributes }))
        }
      })
    }
  }, [])

  return (
    <>
      <Table data={dataRoles} theme={theme} layout={{ fixedHeader: true }} className='sterilizations'>
        {(tableList) => (
          <>
            <Header>
              <HeaderRow>
                <HeaderCell resize={resize}>{t('table.UserRole')}</HeaderCell>
                <HeaderCell resize={resize}>{t('table.Superposition')}</HeaderCell>
                <HeaderCell resize={resize}>{t('table.IsActive')}</HeaderCell>
                <HeaderCell resize={resize}>Actions</HeaderCell>
              </HeaderRow>
            </Header>
            <Body>
              {tableList.map(item =>
                <Row key={item.id} item={item} >
                  <Cell>{item.role}</Cell>
                  <Cell>{item.superposition}</Cell>
                  <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                  <Cell className='table-actions'>
                    <Buttons buttons={[
                      {
                        icon: 'icon-create',
                        cssClass: 'is-info is-small',
                        callback: () => toggleDynamicForm('userRole', null, item)
                      }, {
                        icon: 'icon-privacy_tip',
                        cssClass: 'is-warning is-small',
                        callback: () => goToAuthorizationsPage(item.id)
                      }
                    ]} />
                    {deleteButton(item, item.name, removeUserRole)}
                  </Cell>
                </Row>
              )}
            </Body>
          </>
        )}
      </Table>
    </>
  )
}

export default UserRolesList